module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-lincoln.2a33a6cb.png";